import BaseAPIAuthenConfig from "@/apis/base/BaseAPIAuthenConfig.js";

class ProviderAPI {
    // constructor() {
    //   super();
    //   this.controller = "Provider";
    // }


    /**
     * Đăng nhập
     * @param {} data 
     * @returns 
     */
    login(data){
        return BaseAPIAuthenConfig.post(`provider/login`, data);
    }

    loginMisaId(data){
        return BaseAPIAuthenConfig.post(`provider/login-misaid`, data);
    }

    confirmOtpMisaId(data){
        return BaseAPIAuthenConfig.post(`provider/confirm-otp-misaid`, data);
    }

    /**
     * Thay đổi mật khẩu
     * @param {*} data 
     * @returns 
     */
    changePassword(data){
        return BaseAPIAuthenConfig.post(`provider/change-password`, data);
    }

   
}

export default new ProviderAPI();